"use client";

import * as React from "react";
import { DotsHorizontalIcon, TrashIcon } from "@radix-ui/react-icons";
import { OrganizationDomain } from "../api/endpoint.js";
import { ViewDnsRecordDialog } from "./view-dns-record-dialog.js";
import { DeleteDomainDialog } from "./delete-domain-dialog.js";
import { DropdownMenu, IconButton } from "./elements.js";
import { Translation } from "./i18n/translation.js";
import { useTranslation } from "./i18n/use-translation.js";

interface DomainActionsProps {
  domain: OrganizationDomain;
  onDeleteDomain: (domainId: string) => void;
  onReverifyDomain: (domainId: string) => void;
}

export const DomainActions = ({
  domain,
  onDeleteDomain,
  onReverifyDomain,
}: DomainActionsProps) => {
  const [viewDnsDialogOpen, setViewDnsDialogOpen] = React.useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const translate = useTranslation();

  const removeDomainTitle = translate({
    defaultMessage: "Remove domain",
    id: "Cf+uSR",
    description: "Title for remove domain button",
  });

  const domainActionsTitle = translate({
    defaultMessage: "Domain actions",
    id: "l1mz5q",
    description: "Title for domain actions dropdown button",
  });

  if (domain.state === "Verified") {
    return (
      <>
        <DeleteDomainDialog
          domain={domain}
          onDeleteDomain={onDeleteDomain}
          open={deleteDialogOpen}
          onOpenChange={setDeleteDialogOpen}
        >
          <IconButton title={removeDomainTitle}>
            <TrashIcon />
          </IconButton>
        </DeleteDomainDialog>
      </>
    );
  }

  return (
    <>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <IconButton title={domainActionsTitle}>
            <DotsHorizontalIcon />
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content side="bottom" align="end">
          <DropdownMenu.Item onClick={() => setViewDnsDialogOpen(true)}>
            {domain.state === "Failed" ? (
              <Translation
                defaultMessage="Restart verification"
                id="ZJYAji"
                description="Menu option to restart domain verification"
              />
            ) : (
              <Translation
                defaultMessage="View DNS record"
                id="74JScV"
                description="Menu option to view DNS record"
              />
            )}
          </DropdownMenu.Item>
          <DropdownMenu.Item
            variant="destructive"
            onClick={() => setDeleteDialogOpen(true)}
          >
            <Translation
              defaultMessage="Remove domain"
              id="cO5+D2"
              description="Menu option to remove a domain"
            />
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>

      <ViewDnsRecordDialog
        domain={domain}
        onReverifyDomain={onReverifyDomain}
        open={viewDnsDialogOpen}
        onOpenChange={setViewDnsDialogOpen}
      />

      <DeleteDomainDialog
        domain={domain}
        onDeleteDomain={onDeleteDomain}
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
      />
    </>
  );
};
